if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      // Constructor function for the custom element
      constructor() {
        super();

        // Find the <form> element inside the custom element
        this.form = this.querySelector('form');

        // Enable the input field with the name 'id' inside the form
        this.form.querySelector('[name=id]').disabled = false;

        // Add an event listener to the form's submit event, and bind it to the onSubmitHandler function
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

        // Find the <cart-notification> element on the page
        this.cartNotification = document.querySelector('cart-notification');

        // Find the submit button inside the custom element
        this.submitButton = this.querySelector('[type="submit"]');
      }

      // Function to handle the form's submit event
      onSubmitHandler(evt) {
        // Prevent the default form submission behavior
        evt.preventDefault();

        // If the submit button is disabled, do nothing
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        // Clear any error message shown previously
        this.handleErrorMessage();

        // Set the active element for the cart notification
        this.cartNotification.setActiveElement(document.activeElement);

        // Disable the submit button and show the loading state
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove(
          'hidden'
        );

        // Create a fetch configuration object
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        // Get the form data
        const formData = new FormData(this.form);

        // Append additional data to the form data
        formData.append(
          'sections',
          this.cartNotification
            .getSectionsToRender()
            .map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);

        // Set the fetch request body to the form data
        config.body = formData;

        // Send a fetch request to the cart add URL
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            // Handle the response from the server

            // If there is an error, handle the error message
            if (response.status) {
              this.handleErrorMessage(response.description);

              // Show the sold out message if the product is sold out
              const soldOutMessage =
                this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            // If there is no error, render the cart notification contents
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              // If the form is inside a quick-add-modal, listen for the 'modalClosed' event and delay the rendering of cart notification contents
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cartNotification.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              // If the form is not inside a quick-add-modal, render the cart notification contents immediately
              this.cartNotification.renderContents(response);
            }
            /* NOTE: atari:cart:updated is fired automatically by the
               global fetch intercept in layout/theme.liquid — no need
               to dispatch it here. */
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            // Remove the loading state from the submit button
            this.submitButton.classList.remove('loading');

            // Remove the 'aria-disabled' attribute from the submit button unless there was an error
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');

            // Hide the loading spinner
            this.querySelector('.loading-overlay__spinner').classList.add(
              'hidden'
            );
          });
      }

      // Function to handle error messages
      handleErrorMessage(errorMessage = false) {
        // Find the error message wrapper and error message elements inside the custom element
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        // Toggle the visibility of the error message wrapper based on the presence of an error message
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        // Set the error message text content
        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
